import React, { useEffect } from 'react';
import { Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt, faShieldAlt, faBullhorn } from '@fortawesome/free-solid-svg-icons';
import SafeAdSense from '../shared/SafeAdSense';
import { initAdSense } from '../../services/googleServices';

/**
 * AdPlatformAppCard
 * Google Ads Platform App Card for unauthorized site visitors and CD page visitors.
 * Positioned in the exact same lead slot as the Crypto/Metamask wallet block (NftPlatformAppCard).
 * Highlights the standard/free ad-supported flavour with CTA to upgrade to HealthyMe Pro (ad-free).
 */
const AdPlatformAppCard = ({ className = '' }) => {
  useEffect(() => {
    initAdSense();
  }, []);

  return (
    <div
      className={`beer-item col-12 col-sm-6 col-md-4 p-3 text-center ${className}`}
      data-testid="ad-platform-app-card"
    >
      <div className="details bg-white p-3 h-100 rounded-3 shadow-sm border border-secondary position-relative d-flex flex-column justify-content-between">
        <div>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className="text-muted small">Platform App · CD</span>
            <Badge bg="warning" text="dark" className="small">
              Google Ads
            </Badge>
          </div>
          <h5 className="font-weight-bold mb-1 text-dark">Sponsored Health Metrics</h5>

          <div
            className="my-2 py-2 bg-light rounded-3 d-flex align-items-stretch justify-content-center flex-column overflow-hidden w-100"
            style={{ minHeight: '140px', width: '100%' }}
          >
            <SafeAdSense
              client={process.env.REACT_APP_GADS_ID || 'ca-pub-2835578352930332'}
              slot={process.env.REACT_APP_GADS_SLOT || '7806394673'}
              style={{ display: 'block', width: '100%', minWidth: '200px', minHeight: '100px' }}
              format="auto"
              responsive="true"
              className="w-100"
            />
          </div>

          <p className="text-muted small mb-2">
            Upgrade to PCD (via HealthyMe Pro or HealthSync Pro editions by HealthDash) to eliminate ads.
          </p>
        </div>

        <div className="pt-2 border-top mt-2">
          <a
            href="https://play.google.com/store/apps/details?id=com.linardsl.libhacontimig.hm.finalPro"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-outline-dark btn-sm w-100 fw-bold d-flex align-items-center justify-content-center gap-1 text-decoration-none"
            data-testid="upgrade-pro-button"
          >
            <FontAwesomeIcon icon={faExternalLinkAlt} className="small" />
            <span>Onboard to PCD</span>
          </a>
          <div className="text-muted mt-1" style={{ fontSize: '0.68rem' }}>
            <FontAwesomeIcon icon={faShieldAlt} className="me-1 text-success" />
            Ad-Free with PCD (via HealthyMe Pro or HealthSync Pro editions by HealthDash)
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdPlatformAppCard;

